
import CodeHelpers from './CodeHelpers.js'
import ParseDeclarations from './ParseDeclarations.js'
import ParseInspections from './ParseInspections.js'
import ParseSentences from './ParseSentences.js'

function ParseProcess (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.stable = parser.stable
    this.hintHelper = parser.hintHelper
    this.SC = parser.config
    this.callbacks = parser.callbacks
    this.outline = parser.outline
    this.pcode = parser.pcode
}

ParseProcess.prototype = {
    parse () {
        let procStart
        let procName
        let procEnd
        let autocompleteWithEndProcess = false
        let codeHelpers = new CodeHelpers(this.parser)
        let parseInspections = new ParseInspections(this.parser)
        let parseDeclarations = new ParseDeclarations(this.parser)
        let parseSentences = new ParseSentences(this.parser)

        procStart = this.parser.expect(this.SC.K_PROCESS)
        if (this.hintHelper && procStart === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_PROCESS])
            this.hintHelper.disable()
        }

        procName = this.parser.expect(this.SC.IDENT, procStart)
        if (procName !== false) {
            this.callbacks.procName(procName.lexema)
            this.outline[procName.lexema] = {
                variables: {},
                kind: 'main'
            }
            if (this.hintHelper) {
                this.hintHelper.afterLine(procName)
            }
            if (this.parser.isAutocomplete) {
                if (procStart !== false && procName.line === this.autocompleteLine) {
                    autocompleteWithEndProcess = true
                }
            }
        }
        if (this.parser.compile) {
            procStart.procName = procName.lexema
            this.pcode.start(procStart)
        }

        this.stable.addMethod(procName.lexema, false, procName)
        this.stable.getMethod(procName.lexema).setAsMain()

        this.parser.currentProcName = procName.lexema
        this.stable.enterBlock()

        parseDeclarations.parse(0)

        parseSentences.parse()

        parseInspections.parse(procName.lexema)

        procEnd = this.parser.expect(this.SC.K_END_PROCESS)

        if (this.parser.compile) {
            codeHelpers.codeDeallocateVars(procEnd)
        }

        this.stable.exitBlock()
        this.parser.currentProcName = '_'

        if (this.hintHelper && procEnd === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_END_PROCESS])
            this.hintHelper.disable()
        } else if (this.parser.isAutocomplete && procEnd === false && autocompleteWithEndProcess) {
            this.callbacks.autocomplete(this.SC.K_END_PROCESS.keywords[0], 1)
            this.parser.isAutocomplete = false
        }

        if (this.parser.compile) {
            procEnd.procName = procName.lexema
            this.pcode.end(procEnd)
        }
    }
}

export default ParseProcess



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseProcess.js